import { render } from "./Rock.vue?vue&type=template&id=7430c706"
import script from "./Rock.vue?vue&type=script&lang=js"
export * from "./Rock.vue?vue&type=script&lang=js"
script.render = render

export default script